// extracted by mini-css-extract-plugin
module.exports = {"startup-container":"Startups_startup-container__txFZ8","startup":"Startups_startup__GDkzh","content":"Startups_content__2X6z-","img-container":"Startups_img-container__2wEyC"};